var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-demo",
      attrs: { "default-active": _vm.activeId, mode: "horizontal" },
      on: { select: _vm.handleSelect },
    },
    [
      _vm._l(_vm.routes, function (item, index) {
        return index < _vm.visibleNumber
          ? _c(
              "el-menu-item",
              { attrs: { index: item.id } },
              [
                item.meta && item.meta.icon && item.meta.icon !== "#"
                  ? _c("svg-icon", { attrs: { "icon-class": item.meta.icon } })
                  : _vm._e(),
                _c(
                  "span",
                  {
                    class: item.status == 0 ? "disabledClass" : "normalClass",
                    staticStyle: { "margin-left": "5px" },
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ],
              1
            )
          : _vm._e()
      }),
      _vm.routes.length > _vm.visibleNumber
        ? _c(
            "el-submenu",
            { key: _vm.visibleNumber, attrs: { index: "more" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "normalClass" }, [
                  _vm._v(" 更多菜单 "),
                ]),
              ]),
              _vm._l(_vm.routes, function (item, index) {
                return [
                  index >= _vm.visibleNumber
                    ? _c(
                        "el-menu-item",
                        {
                          key: item.id,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                          attrs: { index: item.id },
                        },
                        [
                          item.meta && item.meta.icon && item.meta.icon !== "#"
                            ? _c("svg-icon", {
                                attrs: { "icon-class": item.meta.icon },
                              })
                            : _vm._e(),
                          _c(
                            "span",
                            {
                              class:
                                item.status == 0
                                  ? "disabledClass"
                                  : "normalClass",
                              staticStyle: { "margin-left": "5px" },
                            },
                            [_vm._v(" " + _vm._s(item.name))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }